/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

const is = require("is_js");

export const formatCostumeFeaturesList = (data: any) => {
  const emptyObj = { name: "...", id: "", isVisible: true };
  if (data && is.existy(data) && is.not.empty(data)) {
    for (let featureObj of data) {
      if (
        is.existy(featureObj) &&
        is.existy(featureObj?.costumeAttributes) &&
        is.not.empty(featureObj?.costumeAttributes)
      ) {
        let visibleFeatureCount: number = 0;
        for (let attributeObj of featureObj?.costumeAttributes) {
          if (is.existy(attributeObj) && attributeObj?.isVisible) {
            visibleFeatureCount++;
          }

          if (
            is.existy(attributeObj) &&
            is.existy(attributeObj?.costumeValues) &&
            is.not.empty(attributeObj?.costumeValues)
          ) {
            let visibleCostumeCount: number = 0;
            for (let costumeObj of attributeObj?.costumeValues) {
              if (
                is.existy(costumeObj) &&
                is.existy(costumeObj) &&
                is.not.empty(costumeObj) &&
                costumeObj?.isVisible
              ) {
                visibleCostumeCount++;
              }
            }
            if (
              visibleCostumeCount > 0 &&
              !attributeObj?.costumeValues.some((e: any) => e.name === "...")
            ) {
              attributeObj?.costumeValues.unshift(emptyObj);
            }
          }
        }
        if (
          visibleFeatureCount > 0 &&
          !featureObj?.costumeAttributes.some((e: any) => e.name === "...")
        ) {
          featureObj?.costumeAttributes.unshift(emptyObj);
        }
      }
    }
  }

  return data;
};

export const formatCostumeTypeData = (
  data: any,
  exchangeRate: any = 1,
) => {
  return {
    headers: {
      presentation: data?.presentation,
      costumeTypeName: data?.name,
      costumeTypeID: data?.id,
      costumeTypeMinDownPayment: data?.minDownPayment,
      status: "Ready",
    },
    costumeFeaturesList: formatCostumeFeaturesList(data?.costumeFeatures),
    exchangeRate,
  };
};
